import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { CurrentAcuityScoreResponse, UUID } from "@/core/types";

import { acuityKeys } from "../keyFactory";
import { getCurrentAcuityScore } from "../queryFunctions/getCurrentAcuityScore";

type UseCurrentAcuityScoreProps<TData = CurrentAcuityScoreResponse> = {
  patientId: UUID;
  select?: (data: CurrentAcuityScoreResponse) => TData;
};

type CurrentAcuityScoreQueryOptions = UseQueryOptions<
  CurrentAcuityScoreResponse,
  unknown,
  CurrentAcuityScoreResponse,
  ReturnType<typeof acuityKeys.current>
>;

export function useCurrentAcuityScore<TData = CurrentAcuityScoreResponse>({
  patientId,
  select,
}: UseCurrentAcuityScoreProps<TData>) {
  return useQuery({ ...optionFactory(patientId), select });
}

function optionFactory(patientId: UUID) {
  return {
    queryFn: () => getCurrentAcuityScore(patientId),
    queryKey: acuityKeys.current(patientId),
    staleTime: 0,
  } satisfies CurrentAcuityScoreQueryOptions;
}
